import type { NgxUiLoaderConfig } from 'ngx-ui-loader';

export const loaderConfig: NgxUiLoaderConfig = {
    blur: 5,
    delay: 0,
    fastFadeOut: true,
    fgsColor: '#009fc1',
    fgsPosition: 'center-center',
    fgsSize: 60,
    fgsType: 'ball-scale-multiple',
    masterLoaderId: 'master',
    overlayBorderRadius: '0',
    overlayColor: 'rgba(255, 255, 255, 0.75)',
    pbColor: '#009fc1',
    pbDirection: 'ltr',
    pbThickness: 3,
    hasProgressBar: true,
    maxTime: -1,
    minTime: 0,
};
